'use client';
import { Theme, styled } from '@mui/material/styles';

import TextField from '@mui/material/TextField';

export const BaseTextField = styled(TextField)<{ inputHeight?: string }>(
  ({
    theme,
    error,
    verified,
    inputHeight,
  }: {
    theme?: Theme;
    error?: boolean;
    verified?: boolean;
    inputHeight?: string;
  }) => ({
    width: '100%',
    backgroundColor: '#fff',
    // height: '50px',
    borderRadius: '10px',
    '& input[type=number]': {
      WebkitAppearance: 'textfield',
      MozAppearance: 'textfield',
      appearance: 'textfield',
      '&:hover, &:focus': {
        appearance: 'textfield',
      },
    },
    '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '& label.Mui-focused': {
      color: '#5F68BC',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: error ? '#E24545' : verified ? '#00C56C' : '#E9E9F4',
        borderRadius: '12px',
      },
      '& .MuiInputBase-input.MuiOutlinedInput-input': {
        fontSize: '16px',
        height: inputHeight || '20px',
      },
      '&:hover fieldset': {
        borderRadius: '12px',
      },
      '&.Mui-focused fieldset': {
        borderColor: error ? '#E24545' : verified ? '#00C56C' : '#f4f4f8',
        borderRadius: '12px',
      },
    },
    '& .MuiFormHelperText-root': {
      marginLeft: '0px',
    },
    '& input:-webkit-autofill': {
      webkitBoxShadow: '0 0 0 30px white inset !important',
      webkitTextFillColor: '#000000 !important',
    },
  })
);
